<template>
  <div class="Crumbs" :class="!$vuetify.breakpoint.smAndDown ? 'expanded' : 'collapsed'">
    <v-icon color="secondaryLight" size="13">stop</v-icon>
    <v-breadcrumbs :items="crumbs">
      <template v-slot:divider>
        <v-icon color="white">navigate_next</v-icon>
      </template>
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item class="white--text">{{ item.name }}</v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </div>
</template>
<script>
import { eventBus } from "@/main";

export default {
  computed: {
    crumbs() {
      let array = this.$route.path.split("/");
      let link = this.$route.path;
      array.shift();
      let name = "";
      if (Array.isArray(array)) {
        name = decodeURIComponent(array[0]);
        if (name.includes("_")) {
          name = name.split("_").join(" ");
        }
      }
      return [{ name, link }];
    },
  },
  methods: {
    linkTo(item) {
      let items = this.crumbs;
      let { name, id, link } = item;
      let route = [];

      eventBus.$emit("notify-nav-items");
      let arr_link = link.split("/");
      arr_link.shift()
      arr_link.forEach((elem, i) => {
        if (i <= id) route.push(elem);
      });

      return `/${route.join("/")}`;
    },
  },
};
</script>
<style scoped>
.Crumbs {
  display: flex;
  justify-content: left;
  align-items: center;
  font-weight: bold;
  text-transform: capitalize;
  letter-spacing: 0.5px;
}
.Crumbs.expanded {
  margin-left: 5px;
}
.Crumbs.collapsed {
  margin-left: 30px;
}
.router-link {
  color: inherit;
  text-decoration: none;
}
</style>
